import React, { Component } from 'react';
import firebase from 'firebase';
import { Grid, Row, Col, ListGroup, ListGroupItem, Badge } from 'react-bootstrap';
import { notify } from 'react-notify-toast';
import ModalFeedback from './ModalFeedback';
import Loading from '../../components/Loading';

type IProps = {
  room: string,
}

type IState = {
  items: Object,
  modal: Object,
  loading: boolean,
}

class Feedback extends Component {

  constructor(props) {
    super(props);

    this.state = {
      items: {},
      modal: null,
      loading: true,
    };
  }

  state: IState;

  componentDidMount() {
    const { room } = this.props;
    
    firebase.database()
    .ref(`room/${room}/feedback`)
    .orderByChild('created_at')
    .on('value', (snapshots) => {
      this.setState({
        items: snapshots.val() || {},
        loading: false,
      });
    });
  }

  handleSave(item: Object) {
    const { room } = this.props;

    const updates = {};
    updates[`room/${room}/feedback/${item.key}/response_text`] = item.response;
    updates[`room/${room}/feedback/${item.key}/response_at`] = Date.now();

    firebase.database().ref().update(updates);

    this.setState({
      modal: null,
    });

    notify.show(`Message sent!`, 'success', 3000);
  }

  handleSelect(key: string) {
    const { items } = this.state;
    this.setState({
      modal: { key, ...items[key] },
    });
  }

  props: IProps;

  render() {
    if (this.state.loading) return <Loading />;

    const { items, modal } = this.state;

    return (
      <Grid>
        <Row style={{ marginBottom: '30px' }}>
          <Col xs={12}>
            <div style={{ float: 'right' }}>
              <Badge bsStyle="default">{Object.keys(items).length} messages</Badge>
            </div>
          </Col>
        </Row>
        <ListGroup>
        {
          Object.keys(items).reverse().map((key) => {
            const item = items[key];
            return (
              <ListGroupItem key={key} header={item.email} onClick={(e) => this.handleSelect(key)} className={!item.response_text && 'list-group-item list-group-item-success'}>
              <p>Message: <strong>{item.text}</strong></p>
              {
                item.response_text && <p>Response: <strong>{item.response_text}</strong></p>
              }
              <p>Sent: <strong>{new Date(item.created_at).toUTCString()}</strong></p>
              </ListGroupItem>
            );
          })
        }
        </ListGroup>
        {
          Object.keys(items).length === 0 && <p>No messages from your students yet</p>
        }

        <ModalFeedback
          item={modal}
          onClose={() => this.setState({ modal: null })} 
          onSave={this.handleSave.bind(this)}
        />

      </Grid>
    );
  }
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/pages/Feedback/index.js